import React, { useState, useEffect } from 'react';
import { projectsAPI } from '../api';
import './ProjectBackers.css';

function ProjectBackers({ projectId }) {
  const [backers, setBackers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBackers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const loadBackers = async () => {
    try {
      const response = await projectsAPI.getBackers(projectId);
      if (response.data.success) {
        setBackers(response.data.backers);
      }
    } catch (error) {
      console.error('Error loading backers:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="card">
        <div className="loading-spinner">Loading backers...</div>
      </div>
    );
  }

  if (backers.length === 0) {
    return null; // Don't show section if no backers
  }

  return (
    <div className="project-backers-section">
      <div className="card">
        <h3 className="section-title-small">
          ❤️ Backers
        </h3>

        {/* Backers List */}
        <div className="backers-grid">
          {backers.map((backer) => (
            <div key={backer.id} className="backer-card">
              <div className="backer-avatar">
                {backer.backer_name.charAt(0).toUpperCase()}
              </div>
              <div className="backer-info">
                <div className="backer-name">{backer.backer_name}</div>
                {backer.tier && (
                  <span className={`backer-tier tier-${backer.tier}`}>
                    {backer.tier}
                  </span>
                )}
                {backer.message && (
                  <p className="backer-message">"{backer.message}"</p>
                )}
                <div className="backer-date">
                  {new Date(backer.created_at).toLocaleDateString('en-US', {
                    month: 'short',
                    year: 'numeric'
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectBackers;
